<!--<ul class="navbar">
  <li class="nav-item" style="float:left">Danh sách lớp đang theo học</li>
  <li class="nav-item active">
    <a class="nav-link" (click)="save_chondoituong()">
      <i style="color:red" class="fa-2x mr-2 far fa-window-close"></i>
      Thoát
    </a>
  </li>

</ul>-->



<div class="row">
  <label class="control-label col-2">Từ Ngày</label>
  <div class="col-2">
    <kendo-dateinput tabindex="1" style="width:100%;" [format]="'dd/MM/yyyy'" (keydown)=onKeydownEvent($event) [(value)]="TimKiems.TuNgay"></kendo-dateinput>
  </div>
  <div class="col-2">
    <kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" (keydown)=onKeydownEvent($event) [(value)]="TimKiems.DenNgay"></kendo-dateinput>
  </div>

  <div class="col-4">
    <button class="btn btn-info btn-primary" style="float:right;margin-right:6px" (click)="search()">
      <i class="fas fa-search"></i>
      {{'Tìm kiếm' | translate}}
    </button>
  </div>
</div>

<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important; height: calc(100vh - 200px)">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Ngày điểm danh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Điểm danh?</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tính buổi</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên lớp</th>
          <th style="text-align:left;background-color:#f3f8fc">Lý do nghỉ</th>

        </tr>

        <tr class="filter-row">
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>

          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TenLop" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.GhiChu" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

        </tr>

      </thead>
      <tbody style="height:calc(100vh - 260px);">
        <tr *ngFor="let u of datas">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="min-width:120px">
            <a>{{u.NgayHoc | date: 'dd/MM/yyyy'}}</a>
          </td>
          <td style="min-width:120px"><a>{{u.DiemDanh}}</a></td>
          <td style="min-width:120px"><a>{{u.TinhBuoi}}</a></td>
          <td style="min-width:120px"><a>{{u.Lop}}</a></td>
          <td>{{u.GhiChu}}</td>

        </tr>
      </tbody>
    </table>


  </div>

</div>





<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>








